<template>
    <base-modal id="browser-storage-permissions-modal" :centered="true" class="global-theme">
        <template slot="title">
            <span class="icon icon-mr icon-glyphicons-basic-circle-empty-alert"></span>
            <span>Additional Browser Permissions Required</span>
        </template>
        <template>
            <div class="py-3">
                <p>Follow the steps below to allow your browser to display this activity:</p>
                <ol>
                    <li class="mb-1">
                        <a href="#" @click.prevent="openVerificationPage()">
                            <span class="mr-1">Launch the browser verification page</span>
                            <span class="icon icon-glyphicons-basic-square-new-window"></span>
                        </a>
                    </li>
                    <li class="mb1">
                        <a href="#" @click.prevent="requestStorageAccess()">
                            <span class="mr-1">Click here to enable browser permissions</span>
                            <span
                                v-if="storageAccessGranted"
                                class="icon icon-glyphicons-basic-circle-check text-success"
                            ></span>
                            <span v-else class="icon icon-glyphicons-basic-switch-off"></span>
                        </a>
                    </li>
                </ol>
            </div>
        </template>
    </base-modal>
</template>

<script>
import BaseModal from "@/components/BaseModal"

export default {
    name: "BrowserStoragePermissionsModal",
    components: {
        BaseModal,
    },
    data() {
        return {
            storageAccessGranted: false,
        }
    },
    methods: {
        // Show the modal.
        show() {
            $("#browser-storage-permissions-modal").modal("show")
        },
        // Request browser storage access. This prompts the user to Allow/Deny access via
        // a native prompt if access hasn't yet been granted.
        requestStorageAccess() {
            let vm = this
            document.requestStorageAccess().then(() => {
                vm.storageAccessGranted = true
                window.location.reload()
            }).catch(() => {
                console.log('Request for browser storage access failed')
            })
        },
        // Open the verification page in a new browser tab. This is done via javascript
        // so that we can close the window with javascript later on.
        openVerificationPage() {
            window.open("/browser/safari-verification", "_blank")
        },
    },
}
</script>

<style>
</style>